module.exports = __webpack_public_path__ + "img/CRKSEF.86267a65.png";